export const autoPlayYoutubePlayerAttributes = {
  playsinline: true,
  muted: true,
  playing: true,
};

export const autoPlayYoutubePlayerConfig = {
  youtube: {
    playerVars: {
      autoplay: 1,
      mute: 1,
      enablejsapi: 1,
      showinfo: 0,
    },
  },
};

export const standardYoutubePlayerAttributes = {
  playsinline: true,
  muted: true,
  playing: false,
};

export const standardYoutubePlayerConfig = {
  youtube: {
    playerVars: {
      autoplay: 0,
      mute: 0,
      enablejsapi: 1,
      showinfo: 0,
    },
  },
};

export const autoPlayVimeoPlayerAttributes = {
  playsinline: true,
  muted: true,
  playing: true,
};

export const autoPlayVimeoPlayerConfig = {
  vimeo: {
    playerOptions: {
      autoplay: true,
      muted: true,
    },
  },
};

export const standardVimeoPlayerAttributes = {
  playsinline: true,
  muted: false,
  playing: false,
  loop: true,
};

export const standardViemoPlayerConfig = {
  vimeo: {
    playerOptions: {
      autoplay: false,
      muted: false,
    },
  },
};
